export type BundleType = "STUDY_PACK" | "PRACTICE_TEST" | "EXAM";
export type ActiveCodesResult = {
	bundle: {
		id: string;
		name: string;
		icon: {
			url: string;
		};
		bundleType: BundleType;
		features: string[];
		isCustomAccess: boolean;
	};
	codes: string[];
};

const fetchActiveCodes = async (
	_tenantId: string,
	_input: string,
): Promise<ActiveCodesResult[]> => {
	return [];
};

export default fetchActiveCodes;
